import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import Button from "components/button";
import moment from "moment";

const REGISTER_DATA = DATA.register;

const Register = () => {
    return (
        <section id='register-id' className="register-block container">
            <p className="title">{REGISTER_DATA.title}</p>
            <div className="content">
                {REGISTER_DATA.content.map((item, index) => {
                    return (
                        <div className="item-wrapper" key={index}>
                            {index === 0 && <img alt="" src="/images/early-bird.png" className="image"/>}
                            <div className="item">
                                <p className="item__label">{item.label}</p>
                                <p className="item__day">{moment(item.registerBefore, 'DD/MM/YYYYTHH:mm:ss').format('DD')}</p>
                                <p className="item__month">{moment(item.registerBefore, 'DD/MM/YYYYTHH:mm:ss').format('MMMM')}</p>
                            </div>
                            <p className="item-wrapper__amount">{item.amount}</p>
                            <Button className="cta" href={DATA['form']} type={index === 0 ? "secondary" : "primary"} content={REGISTER_DATA.cta}/>
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default Register